import React from 'react';
import { Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';
import { Steps, } from '../client/redux/reducers/register-reducer';
import { useIdleTimer } from 'react-idle-timer';
import { ProtectedRoute } from '@alcumus/components';
import environmentVariables from './environmentVariables';
export default function Router() {
    const register = useSelector((state) => state.register);
    useIdleTimer({
        timeout: 1000 * 60 * Number(environmentVariables.SESSION_TIMEOUT_MINUTES || 15),
        events: ['keydown', 'mousedown'],
        onIdle: () => {
            console.log('Session timeout');
            window.location.assign('/');
        },
    });
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/", component: loadable(() => import('./components/RegisterPage')) }),
        React.createElement(Route, { exact: true, path: "/error", component: loadable(() => import('./components/GenericError')) }),
        React.createElement(Route, { exact: true, path: "/activate-account", component: loadable(() => import('./components/ActivationPage')) }),
        React.createElement(Route, { exact: true, path: "/expired-trial", component: loadable(() => import('./components/ExpiredTrialPage')) }),
        React.createElement(Route, { exact: true, path: "/freeTrialExpired", component: loadable(() => import('./components/FreeTrialExpiredPage')) }),
        React.createElement(ProtectedRoute, { exact: true, path: "/welcome", isProtected: register.step !== Steps.QUESTIONNAIRE, component: loadable(() => import('./components/Welcome')) }),
        React.createElement(ProtectedRoute, { exact: true, path: "/questionnaire", isProtected: register.step !== Steps.QUESTIONNAIRE, component: loadable(() => import('./components/QuestionnairePage')) }),
        React.createElement(ProtectedRoute, { exact: true, path: "/questionnaire-test", isProtected: false, component: loadable(() => import('./components/QuestionnairePage')) }),
        React.createElement(ProtectedRoute, { exact: true, path: "/verify-account", isProtected: register.step !== Steps.SUCCESS, component: loadable(() => import('./components/VerifyAccountPage')) })));
}
